<div class="card">
  <app-header
    titulo="Pagamentos não integrados"
    descricao="Pagamentos que ainda não foram integrados"
  ></app-header>

  <app-processamentocontrato></app-processamentocontrato>

</div>
